/**
 * This function holds the execution of the code
 *
 * @param {Number} ms wait time in millisecond
 */
const wait = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export { wait };
